// src/PublicUser/components/tools/CategoryFilter.jsx
import React from 'react';
import { CATEGORIES } from '../../data/FreeTools';

export default function CategoryFilter({ activeCategory, setActiveCategory }) {
  return (
    <div className="ts-tools-filter-section">
      <div className="ts-tools-track">
        {CATEGORIES.map((category) => (
          <button
            key={category}
            className={`ts-tools-btn ${activeCategory === category ? 'ts-active' : ''}`}
            onClick={() => setActiveCategory(category)}
          >
            {category}
          </button>
        ))}
      </div>
    </div>
  );
}